import React, { useMemo } from 'react'
import { getIn } from 'formik'
import PropTypes from 'prop-types'

import GamVideoMediaUpload from './GamVideoMediaUpload'
import GamImageMediaUpload from './GamImageMediaUpload'

import { useMultipleMediaUpload } from '../../../../../../../ReusableFormFields/AdFileUpload/hooks/useMultipleMediaUpload'

import { AD_TYPE_IMAGE, initialGamFileValues, UPLOADED_MEDIA_LIST } from '../../../fields'

const MultipleGamMediaUpload = ({ formik, adType, adSizes }) => {
  const { values, setValues } = formik

  const uploadedMediaList = values[UPLOADED_MEDIA_LIST]
  const carouselItems = getIn(values, UPLOADED_MEDIA_LIST)
  const maxCount = 10

  const { handleDeleteItem } = useMultipleMediaUpload({
    carouselItems,
    maxCount,
    FileItemPath: UPLOADED_MEDIA_LIST,
    initialFileValue: initialGamFileValues,
    setValues,
    values
  })

  const GamMediaUpload = useMemo(() => {
    return adType === AD_TYPE_IMAGE ? GamImageMediaUpload : GamVideoMediaUpload
  }, [adType])

  const emptyItemIndex = useMemo(() => {
    return uploadedMediaList.findIndex(media => !media.media_type)
  }, [uploadedMediaList])

  return (
    <>
      <GamMediaUpload
        // Show empty drag and drop area on the top
        itemPath={`${UPLOADED_MEDIA_LIST}[${emptyItemIndex}]`}
        formik={formik}
        adType={adType}
        adSizes={adSizes}
        index={emptyItemIndex}
        allowMultipleFiles={true}
      />
      {uploadedMediaList.map((media, index) => {
        const mediaPath = `${UPLOADED_MEDIA_LIST}[${index}]`

        const item = getIn(values, mediaPath)
        if (!item.media_type) return null

        return (
          <GamMediaUpload
            key={media.id}
            formik={formik}
            adType={adType}
            itemPath={mediaPath}
            adSizes={adSizes}
            onMediaRemove={() => handleDeleteItem(index)}
            index={index}
            allowMultipleFiles={true}
          />
        )
      })}
    </>
  )
}

MultipleGamMediaUpload.propTypes = {
  adType: PropTypes.string,
  adSizes: PropTypes.arrayOf(PropTypes.object)
}

export default MultipleGamMediaUpload
